import { Box, Button, Container, Grid, Grid2, Paper, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import * as animationData from '../../components/Lottie/noResults.json';
import Footer from '../../components/footer/footer';
import Header from '../../components/header/header';
import { OrderDetail } from '../../components/orderDetail/orderDetail';
import { GET_ORDER_BY_ID } from '../../redux/apis';
import { axiosAuthInstance } from '../../redux/axiosInstance';
import { handlePayment } from '../../utilities/paymentUtils';
import './OrderSuccess.css';

const HEIGHT = window.innerHeight
const WIDTH = window.innerWidth

const OrderSuccess = () => {
    const history = useNavigate();
    const [data, setData] = useState<any>();
    const location = useLocation();
    const { orderId } = location.state || { orderId: 3 };

    useEffect(() => {
        if (!orderId || orderId == '') {
            history("/profile");
        }
        getOrderById();
    }, [])

    const getOrderById = async () => {
        try {
            const response = await axiosAuthInstance.get(`${GET_ORDER_BY_ID}${orderId}`);
            if (response) {
                setData(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    }

    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
            preserveAspectRatio: 'xMidYMid slice'
        }
    };

    return (
        <>
            <Header />
            {/* <Lottie options={defaultOptions}
                width={WIDTH * 50 / 100}
                style={{ flex: 1, marginTop: HEIGHT * 15 / 100 }}
            /> */}
            {data &&
                <Container disableGutters={false} maxWidth={false} sx={{ maxWidth: '1400px', marginTop: 15, }}>
                    <Box style={{ borderRadius: 10, backgroundColor: 'white', marginBottom: HEIGHT * 6 / 100, paddingBottom: HEIGHT * 10 / 100 }}>
                        {/* <img src={require('../../../assets/Home/niruval.jpg')} style={{ marginLeft: WIDTH * 2 / 100, height: HEIGHT * 3 / 100, marginBottom: HEIGHT * 3 / 100 }} /> */}
                        <Grid2 container spacing={2} >
                            <Grid2 size={{ xs: 1, lg: 1 }}>
                                {data.paymentStatus && data.paymentStatus == 'PAID' ?
                                    <Box style={{ display: 'flex', justifyContent: 'center', paddingTop: HEIGHT * 1 / 100, height: HEIGHT * 7 / 100 }} mt={4}>
                                        <img src={require('../../../assets/greencheck.png')} />
                                    </Box> :
                                    <Box style={{ display: 'flex', justifyContent: 'center', paddingTop: HEIGHT * 1 / 100, height: HEIGHT * 7 / 100 }} mt={4}>
                                        <img src={require('../../../assets/wrong.png')} />
                                    </Box>}
                            </Grid2>

                            <Grid2 size={{ xs: 11, lg: 5 }}>
                                <Box>
                                    {data.paymentStatus && data.paymentStatus == 'PAID' ?
                                        <>
                                            <Typography variant="h6" sx={{ mt: 4, mb: 3, color: "green" }}>
                                                <strong>Thank you for your purchase!</strong>
                                            </Typography>
                                            <Typography variant="body1" style={{ color: "rgb(75 69 69)", marginTop: HEIGHT * 2 / 100, marginBottom: HEIGHT * 4 / 100 }}>
                                                Thanks for shopping! Your order <strong>{data.orderNumber}</strong> with <strong>{data && data.orderItems && data.orderItems.length} item(s)</strong> has not shipped yet, but we will send you an email when it does.
                                            </Typography>
                                        </> :
                                        <>
                                            <Typography variant="h6" sx={{ mt: 4, mb: 3, color: "#c92b22" }}>
                                                Sorry. Your payment was not completed. Please try again!
                                            </Typography>
                                            <Typography variant="body1" style={{ color: "rgb(75 69 69)", marginTop: HEIGHT * 2 / 100, marginBottom: HEIGHT * 4 / 100 }}>
                                                Your order <strong>{data.orderNumber}</strong> with <strong>{data && data.orderItems && data.orderItems.length} item(s)</strong> is still pending payment. Kindly compelete the payment to place order.
                                            </Typography>
                                        </>
                                    }
                                </Box>
                                <Box mt={4} mb={4}>
                                    <Paper elevation={0}>
                                        <Typography variant="h6" gutterBottom>
                                            <strong>Shipping Address</strong>
                                        </Typography>
                                        <Typography variant="body1" style={{ marginTop: HEIGHT * 2 / 100, }}>
                                            <strong>{data.shippingAddress.fullName}</strong>
                                        </Typography>
                                        <Typography variant="body2" >
                                            {data.shippingAddress.addressLine1},{" "}
                                            {data.shippingAddress.addressLine2},{" "}
                                            {data.shippingAddress.city}, {data.shippingAddress.district}
                                            , {data.shippingAddress.state},{" "}
                                            {data.shippingAddress.country}
                                        </Typography>
                                        <Typography variant="body2">
                                            {`Pin Code: ${data.shippingAddress.pinCode}, Landmark: ${data.shippingAddress.landMark}`}
                                        </Typography>
                                        <Typography variant="body1" mb={4}>
                                            {`Mob: ${data.shippingAddress.alternateMobileNumber}`}
                                        </Typography>
                                        <Box mt={4} style={{ marginTop: HEIGHT * 4 / 100, }}>
                                            {data.paymentStatus && data.paymentStatus == 'PAID' ? <Button variant="contained" color="primary" onClick={() => { history("/tracknow"); }}>
                                                Track Order
                                            </Button> : <Button variant="contained" color="error" onClick={() => { handlePayment(data, history) }}>
                                                Retry Payment
                                            </Button>}

                                            <Button sx={{ marginLeft: '12px' }} variant="contained" color="success" onClick={() => { history("/"); }}>
                                                Continue Shopping
                                            </Button>
                                        </Box>
                                    </Paper>
                                </Box>
                            </Grid2>
                            <Grid2 size={{ xs: 12, lg: 6 }}>
                                <OrderDetail data={data} showButtons={false} />
                            </Grid2>
                        </Grid2>
                    </Box >
                </Container>
            }
            <Footer />
            {/* </>} */}
        </>
    );
};

export default OrderSuccess;